export default __webpack_public_path__ + "static/media/cp_geo_sk.324bc94c.svg";